<template>
  <div id="app">
    <keep-alive include="index">
      <router-view></router-view>
    </keep-alive>
    <!-- <router-view v-if="!keepAlive"></router-view> -->
    <!-- <router-view></router-view> -->
    <!-- <div class="back-home" v-if="showHome" @click="jumpToHome">
      <van-icon name="user-o" size="1.2rem" />
    </div> -->
    <!-- :path="`/pages-goods/ip-shops/ip-shops?ipid=${user.openId}`" -->

    <!-- <div v-if="isMiniProgram" class="back-home"  @click="backTo">
      <van-icon name="wap-home-o" size="1.4rem" />
    </div> -->

    <!-- <div v-if="!isMiniProgram"> 
      <wx-open-launch-weapp
      id="launch-btn"
      class="back-home"
      username="gh_b542c34c175a"
      :path="`/pages/ip-card-list/ip-card-list.html`"
      @error="handleErrorFn"
      @launch="handleLaunchFn"
      @ready="handleReady"
    >
      <script type="text/wxtag-template">
          <div style="color:white;font-size:12px;text-align:center">首页</div>
      </script>
    </wx-open-launch-weapp>
    </div> -->

  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import * as types from "@/store/types";
import { formatTime, getUrlKey } from '@/utils/utils'
import { get } from '@/utils/request'
export default {
  name: "App",
  data() {
    return {
      showHome: false,
      showBack: false,
      isMiniProgram: false
    };
  },
  computed: {
    ...mapGetters(["user","userId","keepAlive"]),
    ...mapState([
      "jsConfig",
      "shareConfig",
      "wxIsConfiged",
      "user",
      "isProcessingWxPay",
      "companyUrl"
    ]),
    // ...mapState({
    //   isFetching: state => state.isFetching
    // })
  },
  mounted() {},
  methods: {}
}
// import { mapState, mapGetters } from "vuex";
// import * as types from "@/store/types";
// import { formatTime, getUrlKey } from '@/utils/utils'
// import { get } from '@/utils/request'

// export default {
//   name: "App",
//   data() {
//     return {
//       showHome: false,
//       showBack: false,
//       isMiniProgram: false
//     };
//   },
//   computed: {
//     ...mapGetters(["user","userId"]),
//     ...mapState([
//       "jsConfig",
//       "shareConfig",
//       "wxIsConfiged",
//       "user",
//       "isProcessingWxPay",
//     ]),
//     ...mapState({
//       isFetching: state => state.isFetching
//     })
//   },
//   mounted() {
//     this.wx.miniProgram.getEnv((res)=> {
//         if(res.miniprogram){
//           this.isMiniProgram = true
//         } else {
//           this.isMiniProgram = false
//         }
//       })
//     if (location.href.indexOf("ph5") > -1) {
//       document.title = "管理后台";
//     } else {
//       if (location.href.indexOf("webview") > -1) {
//         document.title = "集粽叶赢好礼";
//       } else if (location.href.indexOf("bizsch") > -1) {
//         // document.title = "商学院";
//       } else {
//         document.title = "店主权益";
//       }
//     }

//     let token = localStorage.getItem("token")
//     if(!token || (token === 'null')){
//       let accessKey = getUrlKey("accessKey");
//       if (accessKey) {
//         console.log(accessKey, "accessKey")
//         get("/auth/wechat/getToken?accessKey=" + accessKey).then((res) => {
//           console.log("res===>", res)
//           localStorage.setItem('token', res);
//           return this.getConfigData()
//         })
//       }
//     } else {
//       this.getConfigData()
//     }
//   },
//   watch: {
//     jsConfig(newValue) {
//       // 微信权限注册
//       this.wx.config(newValue);
//     },
//     shareConfig(newValue) {
//       /* 根据路径去写分享成功回调 */
//       const { meta } = this.$route;
//       let args = newValue;
//       // 如果路由被正确的匹配
//       if (meta.shareCallback) {
//         args = {
//           ...newValue,
//           success: () => {
//             meta.shareCallback.call(
//               null,
//               this.$route,
//               this.$store,
//               this.$types
//             );
//           }
//         };
//       }
//       // console.log(args, "args 分享参数", this.$route, meta, newValue)
//       this.wx.ready(() => {
//         this.wx.onMenuShareTimeline(args);
//         this.wx.onMenuShareAppMessage(args);
//         this.wx.updateAppMessageShareData(args);
//         this.wx.updateTimelineShareData(args);
//       });
//     },
//     $route(newValue, oldValue) {
//       const user = this.user.user;
//       const homeDisableLIst = [
//         "/login",
//         "/error/401",
//         "/error",
//         "/error/404",
//         "/wallet/pay",
//         "/wallet",
//         "/home/center",
//         "/home",
//         "/webview/dragon-boat-festival"
//       ];
//       if (homeDisableLIst.includes(newValue.path)) {
//         this.showHome = false;
//         this.showBack = false;
//       } else if (newValue.path.indexOf("bizsch") == 1) {
//         this.showHome = false;
//         this.showBack = true;
//       } else {
//         this.showHome = true;
//         this.showBack = false;
//       }
//       // 路由未发生根本变化（query变化等)
//       // this.$store.commit("toggleWxPayProcessing", false);
//       if (newValue.name == oldValue.name) return;
//       if (!newValue.meta.nosign) {
//         this.$store.dispatch(types.GET_USER).then(() => {});
//       }
//       let link = "";

//       if (
//         newValue.path.indexOf("/wallet/pay") >= 0 &&
//         user && user.inviteCode && user.identityId > 1
//       ) {
//         link = `${location.protocol}//gateway.clyulu.com/auth/wechat/h5?path=${encodeURIComponent(`/wallet/pay`)}&inviteCode=${user &&
//           user.inviteCode}#/wallet/pay`;
//       } else {
//         link = `${location.protocol}//gateway.clyulu.com/auth/wechat/h5?path=${encodeURIComponent(`${this.$route.path}`)}#${
//           this.$route.path
//         }`;
//       }

//       console.log(this);
//       const data = {
//         title: newValue.meta.title, // 分享标题
//         desc:
//           (user && user.inviteCode && user.identityId > 1
//             ? `${user && user.nickname}邀请您查看，`
//             : "") + "腾店邀您享受更多福利功能，赶紧打开看看自己的权益吧！", // 分享描述
//         link,
//         imgUrl: "http://zkplus.oss-cn-shanghai.aliyuncs.com/tdd.png",
//         success:res=>{
//           console.log('调用分享成功！')
//         }
//       };
//       this.wx.ready(() => {
//         this.wx.onMenuShareTimeline(data);
//         this.wx.onMenuShareAppMessage(data);
//         this.wx.updateAppMessageShareData(data);
//         this.wx.updateTimelineShareData(data);
//       });
//     }
//   },
//   methods: {
//     jumpToHome() {
//       this.$router.replace({ path: "/" });
//     },
//     // err
//     handleErrorFn(e) {
//       // alert(e);
//       console.log(e, "e====>")
//     },
//     // launch
//     handleLaunchFn(e) {
//       console.log(e, "e====>")
//       // alert('fail',e.detail);
//     },
//     // Ready
//     handleReady(e) {
//       console.log(e, "e====>")
//       // alert(e)
//     },
//     backTo(){
//       console.log(location.hash.indexOf('bizsch'),location.hash)
//       if(this.isMiniProgram && (location.hash.indexOf('bizsch') > -1)){
//         this.wx.miniProgram.redirectTo({
//           url: `/pages-goods/ip-shops/ip-shops?ipid=${this.$route.params.userId ? this.$route.params.userId : this.userId }`
//         })
//       }
//     },
//     getConfigData(){
//       this.$store.dispatch(types.GET_SITE_CONFIG, {thisUrl: encodeURIComponent(location.href.split("#")[0])}).then(res => {
//         if (res) {
//           console.log(">>>>>>>>>", res);
//           // res.debug = true;
//           this.wx.config(res);
//           return this.$store.dispatch(types.GET_USER);
//         }
//       }).then(user => {
//         if (user) {
//           // let link = `${window.location.origin}wechat/h5?path`
//           let link = `${location.protocol}//${location.hostname}${
//             location.pathname
//           }?path=${encodeURIComponent(`${this.$route.path}`)}#${
//             this.$route.path
//           }`;
//           // debugger
//           // let link = `${location.protocol}//tdd.tddzb.com/wechat/index?path=${encodeURIComponent(`/pay`)}#/pay`; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//           if (user && user.identityId > 1 && this.$route.path.indexOf("/wallet/pay") >= 0) {
//             link = `${location.protocol}//gateway.clyulu.com/auth/wechat/h5?path=${encodeURIComponent(`/wallet/pay`)}&inviteCode=${user &&
//               user.inviteCode}#/wallet/pay`; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//           }
//           const data = {
//             title: this.$route.meta.title || "腾店分享", // 分享标题
//             desc:
//               (user && user.inviteCode && user.identityId > 1
//                 ? `${user && user.nickname}邀请您查看，`
//                 : "") + "腾店邀您享受更多福利功能，赶紧打开看看自己的权益吧！", // 分享描述
//             link,
//             imgUrl: "http://zkplus.oss-cn-shanghai.aliyuncs.com/tdd.png",
//             success:res=>{
//               console.log('调用分享成功！')
//             }
//           };
//           this.wx.ready(() => {
//             this.wx.onMenuShareTimeline(data);
//             this.wx.onMenuShareAppMessage(data);
//             this.wx.updateAppMessageShareData(data);
//             this.wx.updateTimelineShareData(data);
//           });
//         }
//       });
//     }
//   }
// };
</script>
<style lang="scss">
/** 根据设计稿750的素材转换成对应的rem值，配合flexible使用的 */
@function r($pt) {
  @return $pt * 2 / 75 * 1rem;
}

body {
  -webkit-text-size-adjust: none !important;
}
@import "@/scss/commen.scss";
@import "@/scss/main.scss";
@import "@/scss/icon.scss";
#launch-btn{
  width: 50px;
  height: 50px;
  background: gray;
  position: fixed;
  right: 15px;
  bottom: 30px;
  z-index: 2;
}
.back-home {
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 1px 1px 2px 2px #e3e3e3;
  position: fixed;
  right: 15px;
  height: 46px;
  width: 46px;
  bottom: 30px;
}
</style>
